import React, { useCallback, useEffect, useRef, useState } from "react";

import Table from "../../components/table/Table";

import CustomPopup from "../../components/CustomPopup/CustomPopup";
import { Col, Row } from "react-bootstrap";
import CustomInput from "../../components/common/Input/Input";
import { Controller, useForm } from "react-hook-form";

import { api } from "../../api/api";
import { useAuthContext } from "../../ContextAPI/AuthContextAPI";
import moment from "moment";
import { debounce } from "lodash";

const Ticket = () => {
  const { doLogin, currUserData } = useAuthContext();
  const [popupShow, setPopupShow] = useState(false);
  const [data, setData] = useState([]);
  const [editData, setEditData] = useState("");
  const [singleTicket, setSingleTicket] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const handleDelete = async (rowIndex, id) => {
    let res = await api(
      `api/v1/internalEmployee/delete/${id}`,
      {},
      "delete",
      currUserData?.token,
      "Delete Successfully"
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      console.log(res, "delete");
      setData((prevCountryData) => {
        if (!Array.isArray(prevCountryData)) {
          return prevCountryData; // Exit if prevCountryData is not correctly set
        }
        // Filter out the country by index
        const newData = prevCountryData.filter(
          (_, index) => index !== rowIndex
        );
        // Proceed with the backend delete API call
        return newData; // Return the updated data to set the new state
      });
      // setData(res.faqs);
      // setIsLoading(false);
    }
  };

  const handleEdit = async (original) => {
    console.log(original, "jdjdj");
    setPopupShow(true);

    setEditData(original);
    const fields = ["reply", "content", "phone"];

    fields.forEach((field) => setValue(field, original[field]));

    // Find the matching gender option

    // setValue("gender", { label: "Female", value: "Female" });
  };
  const DeleteBlog = async (id) => {
    const res = await api(
      `api/v1/blog/${id}`,
      {},
      "delete",
      currUserData?.token,
      "Blog Deleted"
    );
    if (res && res.success) {
      getTicket();
    }
  };

  const handelSearch = (event) => {
    debouncedSearch(event.target.value);
  };

  const debouncedSearch = useCallback(
    debounce((term) => {
      // Call your search API here
      //   getTicket(term);
      console.log("Searching for:", term);
    }, 500), // Adjust debounce time (in milliseconds)
    []
  );

  const registerOptions = {
    reply: { required: "Reply is required" },
    content: { required: "Content is required" },
  };
  const AddReply = async (data) => {
    console.log(data, singleTicket, "form sdf");

    var payload = {
      senderId: currUserData.id,
      message: data?.reply,
    };

    let res = await api(
      `api/v1/tickets/addConversation/${singleTicket?.ticketId}`,
      payload,
      "post",
      currUserData.token,
      ""
    );
    if (res && res.success) {
      // setSubscriptionData(res?.data);
      setPopupShow(false);
      reset();
      // getTicket();
    }
  };

  const getTicket = async (term = "") => {
    setIsLoading(true);
    let res = await api(
      `api/v1/tickets/getTickets?page=${pageIndex + 1}&limit=${pageSize}`,
      "",
      "get",
      currUserData?.token,
      ""
    );
    if (res && res.success) {
      console.log(res, "res res");
      setData(res?.data);
      setIsLoading(false);
      setTotalCount(res?.total);
    }
  };

  const handleToggleStatus = (rowIndex) => {
    const newData = [...data];
    newData[rowIndex].status = !newData[rowIndex].status;
    setData(newData);
  };

  const handleReplyTicket = (data) => {
    setPopupShow(!popupShow);
    setSingleTicket(data);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Ticket ID",
        accessor: "ticketId",
      },
      {
        Header: "User Name",
        accessor: "userId.name",
      },
      {
        Header: "Email ID",
        accessor: "userId.email",
      },

      //   {
      //     Header: "Status",
      //     accessor: "status",
      //     Cell: ({ row }) => (
      //       <div class="form-check form-switch">
      //         <input
      //           onChange={() => handleToggleStatus(row.index)}
      //           className="form-check-input"
      //           type="checkbox"
      //           id="mySwitch"
      //           name="darkmode"
      //           value="yes"
      //           checked={row.original.status === 1 ? true : false}
      //         />
      //       </div>
      //     ),
      //   },
      {
        Header: "Created On",
        accessor: "createdAt",
        Cell: ({ row }) =>
          moment(row.original.createdAt, "YYYY-MM-DD").format("DD-MM-YYYY"),
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div class="dropdown">
            <span
              data-bs-toggle="dropdown"
              style={{ cursor: "pointer" }}
              aria-expanded="false"
            >
              <i class="fas fa-ellipsis-v"></i>
            </span>
            <ul class="dropdown-menu">
              <li>
                <span
                  className="me-3 cursor-pointer"
                  style={{ cursor: "pointer" }}
                  // onClick={() => {
                  //   handleEdit(row.original);
                  // }}
                >
                  View
                </span>
              </li>
              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => handleReplyTicket(row.original)}
                >
                  Reply
                </span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  useEffect(() => {
    getTicket();
  }, [pageIndex, pageSize]);

  return (
    <>
      <div className="ticket_management">
        <div className="p-40">
          <div className="page_heading mb-4">
            <div>
              <p className="heading">Tickets</p>
            </div>
            {/* <button
              className="btn_primary"
              onClick={() => setPopupShow(!popupShow)}
            >
              
            </button> */}
          </div>

          <div className="ticket_list ">
            <Table
              columns={columns}
              data={data}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onToggleStatus={handleToggleStatus}
              onSearch={handelSearch}
              isLoading={isLoading}
              totalCount={totalCount}
              pageIndex={pageIndex}
              pageSize={pageSize}
              setPageIndex={setPageIndex}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>

      <CustomPopup
        show={popupShow}
        close={setPopupShow}
        closeIcon={true}
        id="Add Reply"
        title="Add Reply"
        bg={false}
        width="md"
      >
        <form className="w-100  p-5" onSubmit={handleSubmit(AddReply)}>
          <Row>
            <Col md="12">
              <CustomInput
                register={register}
                label="Reply"
                name="reply"
                placeholder="e.g., Suraj"
                type={"text"}
                errors={errors.reply}
                validation={registerOptions.reply}
              />
            </Col>
          </Row>
          <button
            className="mx-auto d-block btn_primary w-100 mb-5 mt-5" // onClick={() => navigate("/dashboard")}
          >
            Submit
          </button>
        </form>
      </CustomPopup>
    </>
  );
};

export default Ticket;
